<template>
    <div>
        <nav-breadcrumb :menu="[{label: '留言'}]"/>
        <el-row>
            <el-col>
                <panel label="留言信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">

                            <el-col :span="24">
                                <el-form-item label="发起者：">
                                    {{dataForm.m__senderName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="接受者：">
                                    {{dataForm.m__recipientName}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="留言时间：">
                                    {{dataForm.m__sendTime|moment('YYYY-MM-DD HH:mm:ss')}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="留言内容：">
                                    {{dataForm.m__content}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <panel label="回复信息">
                    <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="24">
                                <el-form-item label="回复时间：">
                                    {{dataForm.m__replyTime|moment('YYYY-MM-DD HH:mm:ss')}}
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="回复内容：">
                                    {{dataForm.m__replies}}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
                <div class="tr xzmt">
                    <el-button @click="$router.back()">返回</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import moment from 'moment';
    export default {
        name: "BranchMessageView",
        data() {
            return {
                messageId:this.$route.query['messageId']||'',
                dataForm:{
                },
                dataFormRules:{},
            }
        },
        mounted() {
            if(this.messageId){
                this.getData()

            }
        },
        methods:{
            getData:function(){
                xhr.getBranchMessage({
                        'm.messageId': this.messageId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.dataForm = res.data.data
                            }
                        }catch (e) {

                        }
                    })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchMessageView.vue